import { useSyncExternalStore } from 'react';

export interface Toast {
  id: number;
  text: string;
}

const SHOW_MS = 8_000;
let toasts: Toast[] = [];
let next = 1;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((fn) => fn());

export function dismiss(id: number) {
  toasts = toasts.filter((t) => t.id !== id);
  emit();
}

/** A notice in the corner for a few seconds: news the server pushed. At most four at once. */
export function toast(text: string) {
  const id = next++;
  toasts = [...toasts, { id, text }].slice(-4);
  emit();
  setTimeout(() => dismiss(id), SHOW_MS);
}

export function useToasts(): Toast[] {
  return useSyncExternalStore(
    (fn) => (listeners.add(fn), () => void listeners.delete(fn)),
    () => toasts,
  );
}
